<template>
  <a :href="bannerUrl" :title="title" class="banner-nav-link">
    <article class="card-banner-container">
      <img :src="imgSrc" :alt="title" class="banner-img" />

      <h3 class="title">{{ title }}</h3>

      <p v-if="!!subTitle" class="subtitle">{{ subTitle }}</p>

      <span v-if="!!ctaLabel" class="cta-label">{{ ctaLabel }}</span>
    </article>
  </a>
</template>

<script>
export default {
  name: 'CardBanner',
  props: {
    bannerUrl: {
      type: String,
      default: '/'
    },
    imgSrc: {
      type: String,
      default: '/'
    },
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: null,
      required: false
    },
    ctaLabel: {
      type: String,
      default: '',
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin ellipse_text {
  display: -webkit-box;
  -webkit-line-clamp: var(--max-lines);
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-banner-container {
  --max-lines: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: left;

  .banner-img {
    width: 100%;
    aspect-ratio: 4 / 3;
    object-fit: cover;
    background-color: #e5e5e5;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.5em;
    margin: 8px 8px 0;
    @include ellipse_text;
  }

  .subtitle {
    --max-lines: 2;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5em;
    margin-inline: 8px;
    @include ellipse_text;
  }

  .cta-label {
    width: fit-content;
    max-width: 200px;
    height: 32px;
    padding-inline: 12px;
    margin: 8px;
    border-radius: 32px;
    border: 1px solid $black;
    background: $white;
    font-size: 12px;
    font-weight: 700;
    line-height: 32px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.banner-nav-link {
  color: $link;

  &:hover {
    color: $link;

    .title,
    .subtitle {
      text-decoration: underline;
    }

    .cta-label {
      background: $black;
      color: $white;
    }
  }
}
</style>
